module.exports = __webpack_public_path__ + "img/signSuccess.15e1402a.png";